<template>
  <div class="mobile-page">
    <div class="page-header">
      <div class="userName flex fd-c ai-fs">
          <div class="t1 nameWOW flipInY"
          data-wow-duration="3s"
          data-wow-delay="0s">石 佳韵</div>
          <div class="t2 nameWOW flipInY name-en"
          data-wow-duration="3s"
          data-wow-delay="0s">SHI JIAYUN</div>
      </div>
      <div class="menu-switch" :class="[menu_open?'open':'']" @click="openMenu"></div>
    </div>
    <router-view :exportYear='year'></router-view>
    <div class="copyright" v-if="info.email">
      
      <div>{{info.copyright}}</div>
    </div>
		<pop-menu :open.sync="menu_open" @changeYear="changeYear"></pop-menu>
  </div>
</template>

<script>
import { site } from '../../api'
import pagemenu from '../component/menu'
export default {
  components:{
      'pop-menu':pagemenu
  },
  props:{},
  data(){
    return {
        menu_open:false,
      nav: [{
        name: 'WORKS',
        color: 'rgba(0, 0, 255, 1)',
        path: '/pc/works',
        isM: true
      },{
        name: 'NEWS',
        color: 'rgba(147, 39, 143, 1)',
        path: '/pc/news',
        isM: true
      },{
        name: 'EXHIBITIONS',
        color: 'rgba(0, 113, 188, 1)',
        path: '/pc/exhibitions',
        isM: true
      },{
        name: 'BIOGRAPHY',
        color: 'rgba(34, 181, 115, 1)',
        path: '/pc/biography',
        isM: true
      }],
      activePath: '',
      info: {},
      year:-1,
    }
  },
  watch:{},
  computed:{},
  methods:{
      openMenu(){
          this.menu_open=!this.menu_open
      },
      changeYear(year){
        this.year=year*1
      },
    navClick(item){
      if (this.activePath==item.path) {return}
      for(var im of this.nav) {
        im.isM = false
      }
      item.isM = true
      this.activePath=item.path
      this.$router.push({path: item.path})
      setTimeout(()=>{
        this.$wow('navWOW')
      }, 10)
      
    },
    site() {
      site({}).then(res=>{
        this.info = JSON.parse(res.data.data)
        localStorage.setItem('siteInfo', res.data.data)
      })
    },
    emailClick() {
      window.open('mailto:'+this.info.email)
    },
    instagram() {
      window.open(this.info.instagram)
    },
    toContact(){
      if(this.$route.name=='CONTACT'){return}
      this.$router.push({name:'CONTACT'})
    }
  },
  created(){
    this.site()
    this.activePath = this.$route.path
  },
  mounted(){
    this.$nextTick(()=>{
        this.$wow('navWOW')
        this.$wow('nameWOW')
    })
    
  }
}
</script>
<style scoped>
    .mobile-page{
      min-height:100vh;
      padding:.4rem .2rem 1rem;
      padding-top:1rem;
      padding-bottom:calc(1rem + constant(safe-area-inset-bottom)); /* 兼容 iOS < 11.2 */
      padding-bottom:calc(1rem + env(safe-area-inset-bottom)); /* 兼容 iOS >= 11.2 */
      line-height:1;
      box-sizing:border-box;

      display: flex;
      flex-direction: column;
    }
    .page-header{
      display:flex;
      position:fixed;
      z-index:9999;
      top:0;
      left:0;
      width:100%;
      padding:.3rem .2rem;
      background-color:#fff;
      box-sizing:border-box;
    }
    .userName{
      flex:1;
      color:#000;
      font-family:Hiragino Sans GB;
      font-size:.27rem;
      font-weight:normal;
    }
    .name-en{
      margin-top:.07rem;
      font-family:Khmer Sangam MN;
      font-size:.2rem;
      font-weight:400;
    }
    .menu-switch{
      position:relative;
      width:.36rem;
      height:.36rem;
      transition:all linear .1s;
    }
    .menu-switch.open{
      transform:rotate(45deg);
    }
    .menu-switch:before,.menu-switch:after{
      content:'';
      position:absolute;
      top:50%;
      left:50%;
      width:.36rem;
      height:.03rem;
      background-color:#000;
      transform:translate(-50%,-50%);
      border-radius:6rem;
    }
    .menu-switch:after{
      transform:translate(-50%,-50%) rotate(90deg);
    }
    .copyright{
      display:flex;
      align-items:center;
      position:fixed;
      z-index:9999;
      bottom:0;
      left:0;
      width:100%;
      padding:.15rem .2rem;
      padding-bottom:.1rem;
      padding-bottom:calc(.15rem + constant(safe-area-inset-bottom)); /* 兼容 iOS < 11.2 */
      padding-bottom:calc(.15rem + env(safe-area-inset-bottom)); /* 兼容 iOS >= 11.2 */
      background-color:#fff;
      font-family:Khmer Sangam MN;
      font-size:.18rem;
      font-weight:400;
      line-height:1;
      box-sizing:border-box;
    }

</style>